// Port of Flutter's HomeCircleMenu / RoomCircleMenu / DeviceCircleMenu — one
// shared widget in Dart too, duplicated three times over. A bottom-right FAB
// that scales a menu panel open above itself (300 ms easeInOut, anchored to the
// bottom-right), with a translucent backdrop that closes it on tap.
//
// items: [{ icon: <Icon/>, title: string, onClick: () => void }]

import React, { useState } from 'react';
import {
  Box, Fab, Grow, Paper, List, ListItemButton, ListItemIcon, ListItemText,
  Divider, useTheme,
} from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import CloseIcon from '@mui/icons-material/Close';

export default function CircleMenu({ items = [] }) {
  const [open, setOpen] = useState(false);
  const theme = useTheme();
  const c = theme.sli;

  if (!items.length) return null;

  return (
    <>
      {open && (
        <Box
          onClick={() => setOpen(false)}
          sx={{ position: 'fixed', inset: 0, zIndex: 1200 }}
        />
      )}

      <Grow in={open} style={{ transformOrigin: 'bottom right' }} timeout={300}>
        <Paper
          elevation={6}
          sx={{
            position: 'fixed',
            right: 20,
            bottom: 90,
            zIndex: 1300,
            maxWidth: 'min(40vw, 320px)',
            minWidth: 200,
            maxHeight: 300,
            overflowY: 'auto',
            borderRadius: '16px',
            bgcolor: c.button,
          }}
        >
          <List disablePadding>
            {items.map((item, i) => (
              <React.Fragment key={item.title}>
                {i > 0 && <Divider sx={{ borderColor: `${c.text}4D` }} />}
                <ListItemButton
                  onClick={() => { setOpen(false); item.onClick(); }}
                  sx={{ px: 2, py: 1.75 }}
                >
                  <ListItemIcon sx={{ minWidth: 36, color: c.text }}>{item.icon}</ListItemIcon>
                  <ListItemText
                    primary={item.title}
                    primaryTypographyProps={{ sx: { color: c.text, fontWeight: 700 } }}
                  />
                </ListItemButton>
              </React.Fragment>
            ))}
          </List>
        </Paper>
      </Grow>

      <Fab
        onClick={() => setOpen((v) => !v)}
        sx={{
          position: 'fixed',
          right: 20,
          bottom: 20,
          zIndex: 1300,
          bgcolor: c.button,
          color: c.text,
          '&:hover': { bgcolor: c.button },
        }}
      >
        {open ? <CloseIcon /> : <MoreVertIcon />}
      </Fab>
    </>
  );
}
